export const FETCH_MOVIES = "FETCH_MOVIES";
export const FETCH_POSTER = "FETCH_POSTER";
